/*=============================================== DemoItem styles ===============================================*/

import styled from "styled-components/macro"
import { Radiuses, Spacers, Mixins } from "tsx-library-julseb"

export const StyledDemoItem = styled.div`
    width: 100%;
    border: 1px solid ${({ theme }) => theme.Gray200};
    border-radius: ${Radiuses.M};

    &.no-content {
        overflow: hidden;
    }
`

export const Content = styled.div`
    padding: ${Spacers.M};
    width: 100%;
    ${Mixins.Flexbox({
        $flexDirection: "column",
        $alignItems: "stretch",
        $gap: "s",
    })}
`

export const Code = styled.div`
    border-radius: 0 0 ${Radiuses.M} ${Radiuses.M};
    overflow: hidden;
`
